// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"651":"31d6cfe0","775":"d7c5a78e"}[chunkId] + ".chunk.css";
};